<ion-card color="primary" class="ion-no-margin ion-no-padding">
  <ion-card-content [ngSwitch]="type" class="ion-no-margin ion-no-padding">


      <!-- Exchange  -->
      <ion-grid *ngSwitchCase="'exchange'">

        <ion-row>
          <ion-col class="ion-align-items-center ion-align-self-center ion-text-center" size="2">
            <ion-button (click)="goBack.emit(true)" class="go-back-button">
              <ion-icon name="return-up-back-outline"></ion-icon>
            </ion-button>
          </ion-col>
          <ion-col class="ion-align-items-center ion-align-self-center ion-text-center" size="8">
            <ion-text i18n>Scambio</ion-text>
            <ion-text>: {{ matrixArray[0] }} X {{ matrixArray[1] }}</ion-text>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col *ngFor="let player of players; index as i;" class="ion-align-items-center ion-align-self-center ion-text-center"
            [ngClass]="{'group-left': ( i % 2 === 0), 'group-right': ( i % 2 > 0)}" size="6">
            <app-player-card [player]="player" (click)="selectPlayer.emit(i)"></app-player-card>
          </ion-col>
        </ion-row>

      </ion-grid>

      <!-- Formation  -->
      <ion-grid *ngSwitchCase="'formation'">
        <ion-row>
          <ion-col class="ion-align-items-center ion-align-self-center ion-text-center" size="2">
            <ion-button (click)="goBack.emit(true)" class="go-back-button">
              <ion-icon name="return-up-back-outline"></ion-icon>
            </ion-button>
          </ion-col>
          <ion-col class="ion-align-items-center ion-align-self-center ion-text-center" size="8">
            <ion-text i18n>Formazione</ion-text>
            <ion-text>: {{ matrixArray[0] }} <span i18n>SU</span> {{ matrixArray[1] }}</ion-text>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col *ngFor="let player of players; index as i;" class="ion-align-items-center ion-align-self-center ion-text-center" size="6">
            <app-player-card [player]="player" (click)="selectPlayer.emit(i)"></app-player-card>
          </ion-col>
        </ion-row>
      </ion-grid>

      <!-- Purchase  -->
      <ion-grid *ngSwitchCase="'purchase'">
        <ion-row>
          <ion-col class="ion-align-items-center ion-align-self-center ion-text-center" size="2">
            <ion-button (click)="goBack.emit(true)" class="go-back-button">
              <ion-icon name="return-up-back-outline"></ion-icon>
            </ion-button>
          </ion-col>
          <ion-col class="ion-align-items-center ion-align-self-center ion-text-center" size="8">
            <ion-text i18n>Acquisto</ion-text>
            <ion-text>: {{ matrixArray[0] }} <span i18n>SU</span> {{ matrixArray[1] }}</ion-text>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col *ngFor="let player of players; index as i;" class="ion-align-items-center ion-align-self-center ion-text-center" size="6">
            <app-player-card [player]="player" (click)="selectPlayer.emit(i)"></app-player-card>
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-button (click)="save()" i18n>
        Salva
      </ion-button>

  </ion-card-content>
</ion-card>
